/** One compose session per tab — binds autosaves to a single server draft. */
const TAB_SESSION_KEY = 'ums-compose-tab-session';
const DRAFT_ID_PREFIX = 'ums-compose-draft-id:';

export function startNewComposeSession(): string {
  const id =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : `compose-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  sessionStorage.setItem(TAB_SESSION_KEY, id);
  return id;
}

export function getComposeSessionId(): string {
  const existing = sessionStorage.getItem(TAB_SESSION_KEY);
  if (existing) return existing;
  return startNewComposeSession();
}

export function readComposeSessionDraftId(sessionId: string): number | null {
  const raw = sessionStorage.getItem(`${DRAFT_ID_PREFIX}${sessionId}`);
  if (!raw) return null;
  const parsed = Number.parseInt(raw, 10);
  return Number.isFinite(parsed) ? parsed : null;
}

export function writeComposeSessionDraftId(sessionId: string, draftId: number): void {
  sessionStorage.setItem(`${DRAFT_ID_PREFIX}${sessionId}`, String(draftId));
}

export function clearComposeSessionDraftId(sessionId: string): void {
  sessionStorage.removeItem(`${DRAFT_ID_PREFIX}${sessionId}`);
}

/** Serialize draft saves so concurrent autosaves cannot create duplicate rows. */
let draftSaveChain: Promise<void> = Promise.resolve();

export function enqueueComposeDraftSave(task: () => Promise<void>): Promise<boolean> {
  const run = draftSaveChain.then(task);
  draftSaveChain = run.catch(() => {
    // keep the chain alive after failures
  });
  return run
    .then(() => true)
    .catch(() => false);
}
